import React from 'react';
import { getImageMedia } from '../helpers';

const HeroImageSlide = ({ slide, slideKey, currentSlide, slidesLength, currentPointIndex, typingStates }) => {
    return (
        <div key={slideKey} className="h-full p-8 flex flex-col justify-center overflow-hidden relative">
            <div className={`grid grid-cols-2 gap-8 w-full items-center min-h-0 ${slide.imagePosition === 'right' ? '' : 'direction-rtl'}`}>
                {/* Contenu texte */}
                <div className={`flex flex-col justify-center min-h-0 overflow-hidden ${slide.imagePosition === 'right' ? '' : 'text-right'}`}>
                    <h2 className="text-5xl pb-1 font-bold mb-3 bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-400 bg-clip-text text-transparent animate-fade-in-up">
                        {slide.title}
                    </h2>
                    <p className="text-xl text-blue-200/60 mb-5 animate-fade-in-up stagger-1">
                        {slide.subtitle}
                    </p>
                    <div className="space-y-2">
                        {slide.points.map((point, i) => (
                            <div key={i} className={`flex items-start gap-3 bg-blue-500/5 p-3 rounded-xl border border-blue-500/10 transition-all ${i < currentPointIndex ? 'opacity-100' :
                                i === currentPointIndex ? 'opacity-100 animate-slide-in' :
                                    'opacity-0'
                                }`}>
                                <div className={`w-2.5 h-2.5 mt-1.5 rounded-full flex-shrink-0 ${i <= currentPointIndex ? 'bg-cyan-400 animate-pulse-glow' : 'bg-blue-500/30'
                                    }`} />
                                <p className="text-xl text-slate-300 m-0 leading-relaxed font-mono flex-1">
                                    {i < currentPointIndex ? point :
                                        i === currentPointIndex ? (
                                            <>
                                                {typingStates[i] || ''}
                                                {typingStates[i] !== point && <span className="typing-cursor"></span>}
                                            </>
                                        ) : ''}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Image — limitée à 65vh pour ne pas déborder du slide */}
                <div className={`flex items-center justify-center py-2 min-h-0 ${slide.imagePosition === 'right' ? '' : 'order-first'}`}>
                    <div
                        className="relative w-full rounded-2xl border-2 border-blue-500/30 bg-gradient-to-br from-slate-800 to-slate-900 flex items-center justify-center overflow-hidden shadow-[0_0_60px_rgba(34,211,238,0.3)]"
                        style={{ maxHeight: '65vh' }}
                    >
                        <div className="absolute inset-0 animate-shimmer" />
                        <div className="relative z-10 w-full h-full flex items-center justify-center p-4">
                            {getImageMedia(slide.image)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroImageSlide;
